import React, { useId } from 'react';

import classNames from 'classnames';

import { QaIdentifier, useQa } from 'hooks/useQa';

import { FormInputProps } from './types';

import styles from './Input.module.scss';

// TODO: this component will replace the input component from Layout in seperate cleanup task - PRPOR-46622
const Input = ({
    customClassList = {},
    labelText,
    placeholder,
    value,
    children,
    callbacks,
    qaId,
    isReadOnly = true,
    forwardRef = null,
}: FormInputProps) => {
    const inputId = useId();
    const qaAttr = useQa(qaId);

    return (
        <div
            className={classNames(
                customClassList?.InputWrapper,
                styles.InputWrapper
            )}
        >
            {labelText && (
                <label
                    className={classNames(customClassList?.Label, styles.Label)}
                    htmlFor={qaId ? QaIdentifier[qaId] : `${inputId}`}
                >
                    {labelText}
                </label>
            )}
            <input
                className={classNames(customClassList?.Input, styles.Input)}
                id={qaId ? QaIdentifier[qaId] : `${inputId}`}
                onClick={callbacks?.onClick}
                onChange={(e) => {
                    callbacks.onValueChange &&
                        callbacks.onValueChange(e.target.value);
                    callbacks.onChange && callbacks.onChange(e.target);
                }}
                onFocus={callbacks?.onFocus}
                onSelect={(e) =>
                    callbacks.onSelect && callbacks.onSelect(e.currentTarget)
                }
                onBlur={callbacks?.onBlur}
                value={value ?? ''}
                placeholder={placeholder}
                readOnly={isReadOnly}
                type="text"
                autoComplete="off"
                ref={forwardRef}
                {...qaAttr}
            />
            {children && (
                <div
                    className={classNames(
                        styles.InputIconWrapper,
                        customClassList?.InputIconWrapper
                    )}
                >
                    {children}
                </div>
            )}
        </div>
    );
};

export default Input;
